<template>
  <v-card class="b-dark">
    <v-card-text>
      <div class="d-flex ga-5">
        <div>
          <img class="item-card-icons" src="@/assets/images/language-icon.svg" />
        </div>
        <div class="d-flex flex-column ga-1 w-100">
          <div class="d-flex justify-space-between w-100 align-center">
            <h4>{{ getDetailName(careerHistory.JobRole) }}</h4>
            <div class="d-flex ga-2">
              <v-btn v-if="!isHiringmanager" icon="mdi-pen" class="c-black b-white" :disabled="loading" @click="edit" />
              <v-btn v-if="!isHiringmanager" icon="mdi-delete" class="c-black b-white" :disabled="loading" @click="remove" />
            </div>
          </div>
          <span class="f-body-1">{{ getDetailName(careerHistory.JobTitle) }} - {{ careerHistory.EmploymentType }} </span>
          <span class="f-body-1 mt-1">{{ getDetailName(careerHistory.CompanyName) }} - {{ careerHistory.Location }} </span>
          <span class="f-body-1 mt-5">{{ careerHistory.Description ? careerHistory.Description : "-" }}</span>
          <div class="d-flex mt-5 justify-md-space-between ga-3 align-md-center flex-column flex-md-row employed-box">
            <span class="f-body-1"
              >{{ formatDate(careerHistory.StartDate) }} - {{ careerHistory.EndDate ? formatDate(careerHistory.EndDate) : "Now" }}</span
            >
            <span class="tertiary_btn align-content-center" v-if="isCurrentlyEmployed()">Currently Employed</span>
          </div>
          <div class="d-flex ga-3 flex-wrap mt-5">
            <v-chip v-for="(item, index) in careerHistory.JobSkills" :key="index" class="b-charcoal">{{ getSkillName(item) }}</v-chip>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import moment from "moment";
import { defineComponent } from "vue";
import Utils from "../../../utils/Utils";

export default defineComponent({
  props: ["careerHistory", "isHiringmanager", "loading", "details", "skills"],
  data() {
    return {};
  },
  methods: {
    isCurrentlyEmployed() {
      return this.careerHistory.StillWorking || moment(this.careerHistory.EndDate).isSameOrAfter(moment(), "day");
    },
    truncate(text: any, length: Number) {
      return Utils.truncate(text, length);
    },
    formatDate(date: any) {
      return moment(date).format("MM/YYYY");
    },
    getDetailName(id: string) {
      return this.details.find((item: any) => item.id == id)?.Name ?? id;
    },
    edit() {
      this.$emit("edit");
    },
    remove() {
      this.$emit("remove");
    },
    getSkillName(skillId: any) {
      var findSkill = this.skills.find((s: any) => s.id === skillId);
      if (findSkill) {
        return findSkill.Text;
      }
    },
  },
  mounted() {},
  watch: {},
});
</script>
<style lang="scss">
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .employed-box {
    width: fit-content;
  }
}
</style>
